<div bsModal #customMobileModal="bs-modal" class="modal fade center-modal trovve-sm-modal" id="fileSelectorMobile" tabindex="-1"
    [config]="{backdrop: 'static',  keyboard: false}">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content box-shadow-popup rounded-12 vh-100">
            <div class="modal-header d-block p-0 border-0">
                <div class="row mx-0">
                    <div class="col px-0 align-self-center font-weight-medium text-vf-dark f-size-16"
                        *ngIf="level === 0">
                        Select item(s) - {{folderDetails?.itemName}}
                    </div>
                    <div class="col px-0 align-self-center font-weight-medium text-vf-dark f-size-16"
                        *ngIf="level === 1">
                        Select Location
                    </div>
                    <div class="col px-0 align-self-center font-weight-medium text-vf-dark f-size-16"
                        *ngIf="level === 2">
                        Select Document Library - <span class="font-weight-bold">{{selectedSiteData?.displayName}}</span>
                    </div>
                    <div class="col px-0 align-self-center font-weight-medium text-vf-dark f-size-16"
                        *ngIf="level === 3">
                        Select item(s) - {{selectedSiteData?.displayName}}<span
                            class="font-weight-bold">/{{selectedDriveData?.name}}</span>
                    </div>
                    <div class="col px-0 align-self-center font-weight-medium text-vf-dark f-size-16"
                        *ngIf="level === 4">
                        <div class="font-weight-medium text-vf-dark f-size-16" *ngIf="selectedItem.length === 1">
                            Select item(s) - OneDrive<span class="font-weight-bold">/{{selectedItem[selectedItem.length
                                -
                                1].name}}</span>
                        </div>
                        <div class="font-weight-medium text-vf-dark f-size-16" *ngIf="selectedItem.length === 2">
                            Select item(s) - {{selectedItem[0].name}}<span
                                class="font-weight-bold">/{{selectedItem[selectedItem.length - 1].name}}</span>
                        </div>
                        <div class="font-weight-medium text-vf-dark f-size-16" *ngIf="selectedItem.length > 2">
                            Select item(s) - {{selectedItem[0].name}}...<span
                                class="font-weight-bold">/{{selectedItem[selectedItem.length - 1].name}}</span>
                        </div>
                    </div>
                    <div class="col px-0 align-self-center font-weight-medium text-vf-dark f-size-16" *ngIf="level > 4">
                        Select item(s) - {{selectedSiteData?.displayName}}...
                        <span class="font-weight-bold">/{{selectedItem[selectedItem?.length - 1]?.name}}</span>
                    </div>
                    <div class="col px-0">
                        <div class="float-right d-flex justify-content-end text-right w-100 h-100">
                            <button type="button" class="float-right d-flex modal-close-icon" (click)="clickClose()"
                                aria-label="Close">
                                <ibm-icon-close size="16"></ibm-icon-close>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-body px-2 py-3 border rounded-8 bg-section mt-3 mx-0 overflow-hidden">
                <div class="file-center-modal" *ngIf="level === 0">
                    <div class="row mb-3">
                        <div class="d-flex pr-0 col-2 pl-4">
                            <div class="custom-control custom-checkbox custom-checkbox-success select-all-checkbox"
                                *ngIf="driveItems.length > 0 && !isSharePointSitesLoading && !isFolderEmpty && !isSingleSelect">
                                <input type="checkbox" class="custom-control-input" id="Select-All-Items"
                                    [checked]="isAllItemsSelected" (change)="selectAllItems()">
                                <label class="custom-control-label pt-05 text-vf-dark" for="Select-All-Items"></label>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="search level-0-search">
                                <div class="input-group">
                                    <div class="input-group-prepend h-100">
                                        <div class="input-group-text"><lucide-icon name="search" [size]="16" [strokeWidth]="2"></lucide-icon>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control rounded-8 text-left bg-pure-white"
                                        placeholder="Search" (input)="applySearchOnLevel0()"
                                        [(ngModel)]="searchTextOnL0">
                                    <div class="input-group-append h-100" style="display: none;">
                                        <button (click)="removeSearchOnLevel0()"
                                            class="input-group-text btn btn-link text-decoration-none px-10">
                                            <ibm-icon-close size="16" class="fill-medium"></ibm-icon-close>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col pl-0 d-flex justify-content-end">
                            <button class="btn modal-header-icon d-flex mr-2" (click)="showAddItem(5)"
                                *ngIf="isSingleSelect">
                                <!-- <lucide-icon name="folder" [size]="14" [strokeWidth]="2" class="mr-2"></lucide-icon> -->
                                <lucide-icon name="folder" [size]="16" class="mr-2"></lucide-icon>
                                <span class="f-size-14 text-vf-dark">Folder</span>
                            </button>
                            <div class="dropdown pr-2" *ngIf="!isSingleSelect">
                                <button class="btn modal-header-icon d-flex" type="button"
                                    id="fileAddDropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <ibm-icon-add size="16" class=""></ibm-icon-add>
                                    <span class="f-size-14 text-vf-dark"></span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right mt-1"
                                    aria-labelledby="fileAddDropdownMenuButton">
                                    <button class="dropdown-item" (click)="showAddItem(1)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                            class="w-16 mr-2" alt="word">
                                        <span class="f-size-14">Word</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(2)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                            class="w-16 mr-2" alt="excel">
                                        <span class="f-size-14">Excel</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(3)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                            class="w-16 mr-2" alt="powerpoint">
                                        <span class="f-size-14 text-none">Powerpoint</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(5)">
                                        <ibm-icon-folder-add size="16" class="mr-2 fill-medium"></ibm-icon-folder-add>
                                        <span class="f-size-14 text-none">Create folder</span>
                                    </button>
                                    <button class="dropdown-item" (click)="triggerFileControlL0()">
                                        <ibm-icon-upload size="16" class="mr-2 fill-medium"></ibm-icon-upload>
                                        <span class="f-size-14 text-none">Upload files</span>
                                    </button>
                                    <input type="file" id="fileUploadOneDrive_L0" style="display: none;" multiple
                                        (change)="fileInputChanged($event, true, level)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-section mb-3" *ngIf="isShowAddItem">
                        <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                            <li class="list-group-item cursor-pointer d-flex">
                                <div class="card-wrapper">
                                    <div class="col px-0 d-flex justify-content-center pl-2" *ngIf="!showFolderOnly">
                                        <div class="dropdown">
                                            <button
                                                class="float-right btn pl-0 tk-proxima-nova text-medium dropdown-toggle"
                                                type="button" id="selectDocTypeMenu" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                    *ngIf="selectedDocType === 1" class="w-20 mr-10" alt="word">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                    *ngIf="selectedDocType === 2" class="w-20 mr-10" alt="excel">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                    *ngIf="selectedDocType === 3" class="w-20 mr-10" alt="powerpoint">
                                                <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10" *ngIf="selectedDocType === 5"></lucide-icon>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right mt-1"
                                                aria-labelledby="selectDocTypeMenu">
                                                <button class="dropdown-item" (click)="selectDocType(1)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                        class="w-20 mr-10" alt="word">
                                                    <span class="f-size-14">Word</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(2)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                        class="w-20 mr-10" alt="excel">
                                                    <span class="f-size-14">Excel</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(3)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                        class="w-20 mr-10" alt="powerpoint">
                                                    <span class="f-size-14 text-none">Powerpoint</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(5)">
                                                    <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon>
                                                    <span class="f-size-14 text-none">Create folder</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-7 pl-0 d-flex">
                                        <!-- <span class="create-input d-flex" *ngIf="selectedDocType !== 5">
                                            <span class="input-text create-file border-none" id="addFileL0"
                                                contenteditable="" (keypress)="onNewFileKeyPress($event, true, level)">
                                            </span>
                                        </span> -->
                                        <input type="text" class="form-control border-0 bg-transparent"
                                            autocomplete="off" [pattern]="pattern" #fileNameInput="ngModel"
                                            id="create-file-input" *ngIf="selectedDocType !== 5"
                                            (keypress)="onNewFileKeyPress($event, true, level)" (blur)="onNewFileBlur($event, false, level)"
                                            [ngClass]="{'is-invalid': fileNameError || fileNameInput.errors?.pattern}"
                                            name="docu-name" placeholder="Type a file name" maxlength="305"
                                            [(ngModel)]="documentName" (ngModelChange)="docNameChange()">
                                        <input type="text" class="form-control border-0 bg-transparent"
                                            autocomplete="off" [pattern]="pattern" #fileNameInput="ngModel"
                                            id="create-folder-input" *ngIf="selectedDocType === 5"
                                            (keypress)="onNewFolderKeyPress($event, true, level)" (blur)="onNewFolderBlur($event, false, level)"
                                            [ngClass]="{'is-invalid': fileNameError || fileNameInput.errors?.pattern}"
                                            name="docu-name" placeholder="Type a folder name" maxlength="305"
                                            [(ngModel)]="documentName" (ngModelChange)="docNameChange()">
                                        <span *ngIf="fileNameError"
                                            class="invalid-feedback text-right">{{fileNameErrorMessage}}</span>
                                        <div *ngIf="fileNameInput?.errors?.pattern" class="invalid-feedback text-right">
                                            Use a name that doesn't include special characters like \ / : * ? " &lt;
                                            &gt; |
                                        </div>
                                        <!-- <span class="create-input d-flex" *ngIf="selectedDocType === 5">
                                            <span class="input-text create-folder border-none" id="addFolderL0"
                                                contenteditable=""
                                                (keypress)="onNewFolderKeyPress($event, true, level)">
                                            </span>
                                        </span> -->
                                    </div>
                                    <div class="col d-flex px-0 justify-content-end">
                                        <span class="f-size-14 text-blue cursor-pointer">
                                            <span class="ml-1">Save</span>
                                        </span>
                                    </div>
                                </div>
                            </li>
                            <span class="d-flex justify-content-end my-2">
                                <span class="text-vf-dark cursor-pointer f-size-14 font-weight-medium"
                                    *ngIf="isFromProject" (click)="autoFillTitle()">
                                    <ibm-icon-edit size="16" class="mr-2"></ibm-icon-edit>
                                    Auto-fill with {{projectLabelLower}} name
                                </span>
                            </span>
                        </ul>
                    </div>
                    <div [hidden]="!isSharePointSitesLoading" class="my-10 mx-10">
                        <div class="skeleton skeleton-tile"></div>
                    </div>
                    <perfect-scrollbar [config]="config" (psYReachEnd)="getMoreMyFiles($event)">
                        <div class="card-section pb-2"
                            *ngIf="driveItems.length > 0 && !isSharePointSitesLoading && !isFolderEmpty && !noResultFound">
                            <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                                <ng-template ngFor let-i="index" let-item [ngForOf]="driveItems">
                                    <li class="list-group-item cursor-pointer d-flex" *ngIf="item.isShow">
                                        <div class="card-wrapper">
                                            <div class="col px-0 d-flex justify-content-center">
                                                <div class="custom-control custom-checkbox custom-checkbox-success">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="Opt4-{{item.id}}" [checked]="item.isSelected"
                                                        (change)="selectItem(item)">
                                                    <label class="custom-control-label" for="Opt4-{{item.id}}"></label>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-center"
                                                (click)="item.extension === 'folder' ? goToL5FromL0(item) : selectItem(item)">
                                                <vf-file-icon [obj]="item" [isSemibold]="true"></vf-file-icon>
                                            </div>
                                            <div class="col-7 pl-1"
                                                (click)="item.extension === 'folder' ? goToL5FromL0(item) : selectItem(item)">
                                                <div class="row ml-0 flex-nowrap">
                                                    <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14"
                                                        href="javascript:;"> {{item.name}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-end"
                                                (click)="item.extension === 'folder' ? goToL5FromL0(item) : selectItem(item)">
                                                <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"
                                                    *ngIf="item.extension === 'folder'"></lucide-icon>
                                            </div>
                                        </div>
                                    </li>
                                </ng-template>
                            </ul>
                        </div>
                        <div [hidden]="!isMoreDataLoading" class="my-10 mx-10">
                            <div class="skeleton skeleton-tile"></div>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="isFolderEmpty && !isSharePointSitesLoading && !noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                This folder is empty
                            </p>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="!isFolderEmpty && !isSharePointSitesLoading && noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                We can't find anything matching your search terms.
                            </p>
                        </div>
                    </perfect-scrollbar>
                </div>
                <div class="file-center-modal" *ngIf="level === 1">
                    <div class="card-section mb-3">
                        <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                            <li class="list-group-item cursor-pointer d-flex" (click)="getMyFilesOnOneDrive()">
                                <div class="card-wrapper">
                                    <div class="col d-flex px-0 justify-content-center">
                                        <img class="text-center w-15"
                                            src="https://cdn.trovve.com/vfapp/images/app-icons/Onedrive.svg">
                                    </div>
                                    <div class="col-10 pl-1">
                                        <div class="row ml-0 flex-nowrap">
                                            <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14"
                                                href="javascript:;"> OneDrive
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col d-flex px-0 justify-content-end">
                                        <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"></lucide-icon>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="row border-bottom mx-2">
                    </div>
                    <div class="row mt-3 mb-15 mx-2">
                        <div class="col px-0">
                            <div class="f-size-15 font-weight-semibold text-body">
                                From SharePoint
                            </div>
                        </div>
                    </div>
                    <div [hidden]="!isSharePointSitesLoading" class="my-10 mx-10">
                        <div class="skeleton skeleton-tile"></div>
                    </div>
                    <perfect-scrollbar [config]="config">
                        <div class="card-section pb-2" *ngIf="sharePointSitesData.length > 0">
                            <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                                <ng-template ngFor let-i="index" let-item [ngForOf]="sharePointSitesData">
                                    <li class="list-group-item cursor-pointer d-flex"
                                        (click)="goToDrivesBySiteId(item)">
                                        <div class="card-wrapper">
                                            <div class="col d-flex px-0 justify-content-center">
                                                <img class="text-center w-15"
                                                    src="https://cdn.trovve.com/vfapp/images/app-icons/SharePoint.svg">
                                            </div>
                                            <div class="col-10 pl-1">
                                                <div class="row ml-0 flex-nowrap">
                                                    <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14"
                                                        href="javascript:;">
                                                        {{item.displayName}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-end">
                                                <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"></lucide-icon>
                                            </div>
                                        </div>
                                    </li>
                                </ng-template>
                            </ul>
                        </div>
                    </perfect-scrollbar>
                </div>
                <div class="file-center-modal" *ngIf="level === 2">
                    <div class="row mb-3">
                        <div class="d-flex pr-0 col-2 pl-4">
                            <div class="custom-control custom-checkbox custom-checkbox-success select-all-checkbox"
                                *ngIf="selectedSiteData.drives.length > 0 && !isSingleSelect">
                                <input type="checkbox" class="custom-control-input" id="Select-All-Library"
                                    [checked]="isAllLibrarySelected" (change)="selectAllLibrary()">
                                <label class="custom-control-label pt-05 text-vf-dark" for="Select-All-Library"></label>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="search level-2-search">
                                <div class="input-group">
                                    <div class="input-group-prepend h-100">
                                        <div class="input-group-text"><lucide-icon name="search" [size]="16" [strokeWidth]="2"></lucide-icon>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control rounded-8 text-left bg-pure-white"
                                        placeholder="Search" (input)="applySearchOnLevel2()"
                                        [(ngModel)]="searchTextOnL2">
                                    <div class="input-group-append h-100" style="display: none;">
                                        <button (click)="removeSearchOnLevel2()"
                                            class="input-group-text btn btn-link text-decoration-none px-10">
                                            <ibm-icon-close size="16" class="fill-medium"></ibm-icon-close>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col pl-0 d-flex justify-content-end">
                            <button class="btn modal-header-icon d-flex mr-2" type="button" (click)="showAddLibrary()">
                                <ibm-icon-add size="16" class=""></ibm-icon-add>
                                <span class="f-size-14 text-vf-dark"></span>
                            </button>
                        </div>
                    </div>
                    <div class="card-section mb-3" *ngIf="isShowAddLibrary">
                        <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                            <li class="list-group-item cursor-pointer d-flex">
                                <div class="card-wrapper">
                                    <div class="col px-0 d-flex justify-content-center pl-2">
                                        <lucide-icon name="folder" [size]="16"></lucide-icon>
                                    </div>
                                    <div class="col-8 d-flex">
                                        <span class="create-input d-flex">
                                            <span class="input-text create-library border-none" contenteditable=""
                                                (keypress)="onNewLibKeyPress($event)"
                                                (blur)="onNewLibBlur($event)"></span>
                                        </span>
                                    </div>
                                    <div class="col d-flex px-0 justify-content-end">
                                        <span class="f-size-14 text-blue cursor-pointer">
                                            <span class="ml-1">Save</span>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div [hidden]="!isSharePointSitesLoading" class="my-10 mx-10">
                        <div class="skeleton skeleton-tile"></div>
                    </div>
                    <perfect-scrollbar [config]="config">
                        <div class="card-section pb-2" *ngIf="selectedSiteData.drives.length > 0 && !noResultFound">
                            <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                                <ng-template ngFor let-i="index" let-item [ngForOf]="selectedSiteData.drives">
                                    <li class="list-group-item cursor-pointer d-flex" *ngIf="item.isShow">
                                        <div class="card-wrapper">
                                            <div class="col px-0 d-flex justify-content-center">
                                                <div class="custom-control custom-checkbox custom-checkbox-success">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="Opt-{{item.id}}" [checked]="item.isSelected"
                                                        (change)="selectDrive(item)">
                                                    <label class="custom-control-label" for="Opt-{{item.id}}"></label>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-center"
                                                (click)="goToChildrenOfDrive(item)">
                                                <lucide-icon name="folder" [size]="16"></lucide-icon>
                                            </div>
                                            <div class="col-7 pl-1" (click)="goToChildrenOfDrive(item)">
                                                <div class="row ml-0 flex-nowrap">
                                                    <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14"
                                                        href="javascript:;"> {{item.name}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-end"
                                                (click)="goToChildrenOfDrive(item)">
                                                <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"></lucide-icon>
                                            </div>
                                        </div>
                                    </li>
                                </ng-template>
                            </ul>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="isFolderEmpty && !isSharePointSitesLoading && !noResultFound && !isShowAddLibrary">
                            <p class="f-size-14 text-center mb-0">
                                This folder is empty
                            </p>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="!isFolderEmpty && !isSharePointSitesLoading && noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                We can't find anything matching your search terms.
                            </p>
                        </div>
                    </perfect-scrollbar>
                </div>
                <div class="file-center-modal" *ngIf="level === 3">
                    <div class="row mb-3">
                        <div class="d-flex pr-0 col-2 pl-4">
                            <div class="custom-control custom-checkbox custom-checkbox-success select-all-checkbox"
                                *ngIf="selectedDriveData.children.length > 0 && !isFolderEmpty && !isSingleSelect">
                                <input type="checkbox" class="custom-control-input" id="Select-All-Drives"
                                    [checked]="isAllDrivesSelected" (change)="selectAllDrives()">
                                <label class="custom-control-label pt-05 text-vf-dark" for="Select-All-Drives"></label>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="search level-3-search">
                                <div class="input-group">
                                    <div class="input-group-prepend h-100">
                                        <div class="input-group-text"><lucide-icon name="search" [size]="16" [strokeWidth]="2"></lucide-icon>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control rounded-8 text-left bg-pure-white"
                                        placeholder="Search" (input)="applySearchOnLevel3()"
                                        [(ngModel)]="searchTextOnL3">
                                    <div class="input-group-append h-100" style="display: none;">
                                        <button (click)="removeSearchOnLevel3()"
                                            class="input-group-text btn btn-link text-decoration-none px-10">
                                            <ibm-icon-close size="16" class="fill-medium"></ibm-icon-close>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col pl-0 d-flex justify-content-end">
                            <button class="btn modal-header-icon d-flex mr-2" (click)="showAddItem(5)"
                                *ngIf="isSingleSelect">
                                <!-- <lucide-icon name="folder" [size]="14" [strokeWidth]="2" class="mr-2"></lucide-icon> -->
                                <lucide-icon name="folder" [size]="16" class="mr-2"></lucide-icon>
                                <span class="f-size-14 text-vf-dark">Folder</span>
                            </button>
                            <div class="dropdown pr-2" *ngIf="!isSingleSelect">
                                <button class="btn modal-header-icon d-flex" type="button"
                                    id="fileAddDropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <ibm-icon-add size="16" class=""></ibm-icon-add>
                                    <span class="f-size-14 text-vf-dark"></span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right mt-1"
                                    aria-labelledby="fileAddDropdownMenuButton">
                                    <button class="dropdown-item" (click)="showAddItem(1)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                            class="w-16 mr-2" alt="word">
                                        <span class="f-size-14">Word</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(2)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                            class="w-16 mr-2" alt="excel">
                                        <span class="f-size-14">Excel</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(3)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                            class="w-16 mr-2" alt="powerpoint">
                                        <span class="f-size-14 text-none">Powerpoint</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(5)">
                                        <ibm-icon-folder-add size="16" class="mr-2 fill-medium"></ibm-icon-folder-add>
                                        <span class="f-size-14 text-none">Create folder</span>
                                    </button>
                                    <button class="dropdown-item" (click)="triggerFileControlL3()">
                                        <ibm-icon-upload size="16" class="mr-2 fill-medium"></ibm-icon-upload>
                                        <span class="f-size-14 text-none">Upload files</span>
                                    </button>
                                    <input type="file" id="fileUploadOneDrive_L3" style="display: none;" multiple
                                        (change)="fileInputChanged($event, false, level)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-section mb-3" *ngIf="isShowAddItem">
                        <ul class="list-group text-medium project-file-list-group px-0">
                            <li class="list-group-item cursor-pointer d-flex">
                                <div class="card-wrapper mr-2">
                                    <div class="col px-0 d-flex justify-content-center pl-2" *ngIf="!showFolderOnly">
                                        <div class="dropdown">
                                            <button
                                                class="float-right btn pl-0 tk-proxima-nova text-medium dropdown-toggle"
                                                type="button" id="selectDocTypeMenu" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                    *ngIf="selectedDocType === 1" class="w-20 mr-10" alt="word">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                    *ngIf="selectedDocType === 2" class="w-20 mr-10" alt="excel">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                    *ngIf="selectedDocType === 3" class="w-20 mr-10" alt="powerpoint">
                                                <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10" *ngIf="selectedDocType === 5"></lucide-icon>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right mt-1"
                                                aria-labelledby="selectDocTypeMenu">
                                                <button class="dropdown-item" (click)="selectDocType(1)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                        class="w-20 mr-10" alt="word">
                                                    <span class="f-size-14">Word</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(2)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                        class="w-20 mr-10" alt="excel">
                                                    <span class="f-size-14">Excel</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(3)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                        class="w-20 mr-10" alt="powerpoint">
                                                    <span class="f-size-14 text-none">Powerpoint</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(5)">
                                                    <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon>
                                                    <span class="f-size-14 text-none">Create folder</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-8 pl-0 d-flex">
                                        <span class="create-input d-flex" *ngIf="selectedDocType !== 5">
                                            <span class="input-text create-file border-none" contenteditable=""
                                                (keypress)="onNewFileKeyPress($event, false, level)"
                                                (blur)="onNewFileBlur($event, false, level)"></span>
                                        </span>
                                        <span class="create-input d-flex" *ngIf="selectedDocType === 5">
                                            <span class="input-text create-folder border-none" contenteditable=""
                                                (keypress)="onNewFolderKeyPress($event, false, level)"
                                                (blur)="onNewFolderBlur($event, false, level)"></span>
                                        </span>
                                    </div>
                                    <div class="col d-flex px-0 justify-content-end">
                                        <span class="f-size-14 text-vf-dark cursor-pointer">
                                            <span class="ml-1">Save</span>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div [hidden]="!isSharePointSitesLoading" class="my-10 mx-10">
                        <div class="skeleton skeleton-tile"></div>
                    </div>
                    <perfect-scrollbar [config]="config" (psYReachEnd)="getMoreChildrenOfDrive($event)">
                        <div class="card-section pb-2"
                            *ngIf="selectedDriveData.children.length > 0 && !isFolderEmpty && !noResultFound">
                            <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                                <ng-template ngFor let-i="index" let-item [ngForOf]="selectedDriveData.children">
                                    <li class="list-group-item cursor-pointer d-flex" *ngIf="item.isShow">
                                        <div class="card-wrapper">
                                            <div class="col px-0 d-flex justify-content-center">
                                                <div class="custom-control custom-checkbox custom-checkbox-success">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="Opt3-{{item.id}}" [checked]="item.isSelected"
                                                        (change)="selectDriveItem(item)">
                                                    <label class="custom-control-label" for="Opt3-{{item.id}}"></label>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-center"
                                                (click)="item.extension === 'folder' ? getDriveItems(item) : selectDriveItem(item)">
                                                <vf-file-icon [obj]="item" [isSemibold]="true"></vf-file-icon>
                                            </div>
                                            <div class="col-7 pl-1"
                                                (click)="item.extension === 'folder' ? getDriveItems(item) : selectDriveItem(item)">
                                                <div class="row ml-0 flex-nowrap">
                                                    <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14"
                                                        href="javascript:;"> {{item.name}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-end"
                                                (click)="item.extension === 'folder' ? getDriveItems(item) : selectDriveItem(item)">
                                                <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"
                                                    *ngIf="item.extension === 'folder'"></lucide-icon>
                                            </div>
                                        </div>
                                    </li>
                                </ng-template>
                            </ul>
                        </div>
                        <div [hidden]="!isMoreDataLoading" class="my-10 mx-10">
                            <div class="skeleton skeleton-tile"></div>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="isFolderEmpty && !isSharePointSitesLoading && !noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                This folder is empty
                            </p>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="!isFolderEmpty && !isSharePointSitesLoading && noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                We can't find anything matching your search terms.
                            </p>
                        </div>
                    </perfect-scrollbar>
                </div>
                <div class="file-center-modal" *ngIf="level === 4">
                    <div class="row mb-3">
                        <div class="d-flex pr-0 col-2 pl-4">
                            <div class="custom-control custom-checkbox custom-checkbox-success select-all-checkbox"
                                *ngIf="driveItems.length > 0 && !isSharePointSitesLoading && !isFolderEmpty && !isSingleSelect">
                                <input type="checkbox" class="custom-control-input" id="Select-All-Items"
                                    [checked]="isAllItemsSelected" (change)="selectAllItems()">
                                <label class="custom-control-label pt-05 text-vf-dark" for="Select-All-Items"></label>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="search level-4-search">
                                <div class="input-group">
                                    <div class="input-group-prepend h-100">
                                        <div class="input-group-text"><lucide-icon name="search" [size]="16" [strokeWidth]="2"></lucide-icon>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control rounded-8 text-left bg-pure-white"
                                        placeholder="Search" (input)="applySearchOnLevel4()"
                                        [(ngModel)]="searchTextOnL4">
                                    <div class="input-group-append h-100" style="display: none;">
                                        <button (click)="removeSearchOnLevel4()"
                                            class="input-group-text btn btn-link text-decoration-none px-10">
                                            <ibm-icon-close size="16" class="fill-medium"></ibm-icon-close>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col pl-0 d-flex justify-content-end">
                            <button class="btn modal-header-icon d-flex mr-2" (click)="showAddItem(5)"
                                *ngIf="isSingleSelect">
                                <!-- <lucide-icon name="folder" [size]="14" [strokeWidth]="2" class="mr-2"></lucide-icon> -->
                                <lucide-icon name="folder" [size]="16" class="mr-2"></lucide-icon>
                                <span class="f-size-14 text-vf-dark">Folder</span>
                            </button>
                            <div class="dropdown pr-2" *ngIf="!isSingleSelect">
                                <button class="btn modal-header-icon d-flex" type="button"
                                    id="fileAddDropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <ibm-icon-add size="16" class=""></ibm-icon-add>
                                    <span class="f-size-14 text-vf-dark"></span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right mt-1"
                                    aria-labelledby="fileAddDropdownMenuButton">
                                    <button class="dropdown-item" (click)="showAddItem(1)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                            class="w-16 mr-2" alt="word">
                                        <span class="f-size-14">Word</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(2)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                            class="w-16 mr-2" alt="excel">
                                        <span class="f-size-14">Excel</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(3)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                            class="w-16 mr-2" alt="powerpoint">
                                        <span class="f-size-14 text-none">Powerpoint</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(5)">
                                        <ibm-icon-folder-add size="16" class="mr-2 fill-medium"></ibm-icon-folder-add>
                                        <span class="f-size-14 text-none">Create folder</span>
                                    </button>
                                    <button class="dropdown-item" (click)="triggerFileControlL4()">
                                        <ibm-icon-upload size="16" class="mr-2 fill-medium"></ibm-icon-upload>
                                        <span class="f-size-14 text-none">Upload files</span>
                                    </button>
                                    <input type="file" id="fileUploadOneDrive_L4" style="display: none;" multiple
                                        (change)="fileInputChanged($event, true, level)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-section mb-3" *ngIf="isShowAddItem">
                        <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                            <li class="list-group-item cursor-pointer d-flex">
                                <div class="card-wrapper">
                                    <div class="col px-0 d-flex justify-content-center pl-2" *ngIf="!showFolderOnly">
                                        <div class="dropdown">
                                            <button
                                                class="float-right btn pl-0 tk-proxima-nova text-medium dropdown-toggle"
                                                type="button" id="selectDocTypeMenu" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                    *ngIf="selectedDocType === 1" class="w-20 mr-10" alt="word">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                    *ngIf="selectedDocType === 2" class="w-20 mr-10" alt="excel">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                    *ngIf="selectedDocType === 3" class="w-20 mr-10" alt="powerpoint">
                                                <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10" *ngIf="selectedDocType === 5"></lucide-icon>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right mt-1"
                                                aria-labelledby="selectDocTypeMenu">
                                                <button class="dropdown-item" (click)="selectDocType(1)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                        class="w-20 mr-10" alt="word">
                                                    <span class="f-size-14">Word</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(2)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                        class="w-20 mr-10" alt="excel">
                                                    <span class="f-size-14">Excel</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(3)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                        class="w-20 mr-10" alt="powerpoint">
                                                    <span class="f-size-14 text-none">Powerpoint</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(5)">
                                                    <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon>
                                                    <span class="f-size-14 text-none">Create folder</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-8 pl-0 d-flex">
                                        <span class="create-input d-flex" *ngIf="selectedDocType !== 5">
                                            <span class="input-text create-file border-none" contenteditable=""
                                                (keypress)="onNewFileKeyPress($event, true, level)"
                                                (blur)="onNewFileBlur($event, true, level)"></span>
                                        </span>
                                        <span class="create-input d-flex" *ngIf="selectedDocType === 5">
                                            <span class="input-text create-folder border-none" contenteditable=""
                                                (keypress)="onNewFolderKeyPress($event, true, level)"
                                                (blur)="onNewFolderBlur($event, true, level)"></span>
                                        </span>
                                    </div>
                                    <div class="col d-flex px-0 justify-content-end">
                                        <span class="f-size-14 text-blue cursor-pointer">
                                            <span class="ml-1">Save</span>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div [hidden]="!isSharePointSitesLoading" class="my-10 mx-10">
                        <div class="skeleton skeleton-tile"></div>
                    </div>
                    <perfect-scrollbar [config]="config" (psYReachEnd)="getMoreMyFiles($event)">
                        <div class="card-section pb-2"
                            *ngIf="driveItems.length > 0 && !isSharePointSitesLoading && !isFolderEmpty && !noResultFound">
                            <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                                <ng-template ngFor let-i="index" let-item [ngForOf]="driveItems">
                                    <li class="list-group-item cursor-pointer d-flex" *ngIf="item.isShow">
                                        <div class="card-wrapper">
                                            <div class="col px-0 d-flex justify-content-center">
                                                <div class="custom-control custom-checkbox custom-checkbox-success">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="Opt4-{{item.id}}" [checked]="item.isSelected"
                                                        (change)="selectItem(item)">
                                                    <label class="custom-control-label" for="Opt4-{{item.id}}"></label>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-center"
                                                (click)="item.extension === 'folder' ? onItemSelected(item) : selectItem(item)">
                                                <vf-file-icon [obj]="item" [isSemibold]="true"></vf-file-icon>
                                            </div>
                                            <div class="col-7 pl-1"
                                                (click)="item.extension === 'folder' ? onItemSelected(item) : selectItem(item)">
                                                <div class="row ml-0 flex-nowrap">
                                                    <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14"
                                                        href="javascript:;"> {{item.name}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-end"
                                                (click)="item.extension === 'folder' ? onItemSelected(item) : selectItem(item)">
                                                <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"
                                                    *ngIf="item.extension === 'folder'"></lucide-icon>
                                            </div>
                                        </div>
                                    </li>
                                </ng-template>
                            </ul>
                        </div>
                        <div [hidden]="!isMoreDataLoading" class="my-10 mx-10">
                            <div class="skeleton skeleton-tile"></div>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="isFolderEmpty && !isSharePointSitesLoading && !noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                This folder is empty
                            </p>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="!isFolderEmpty && !isSharePointSitesLoading && noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                We can't find anything matching your search terms.
                            </p>
                        </div>
                    </perfect-scrollbar>
                </div>
                <div class="file-center-modal" *ngIf="level > 4">
                    <div class="row mb-3">
                        <div class="d-flex pr-0 col-2 pl-4">
                            <div class="custom-control custom-checkbox custom-checkbox-success select-all-checkbox"
                                *ngIf="driveItems.length > 0 && !isSharePointSitesLoading && !isFolderEmpty && !isSingleSelect">
                                <input type="checkbox" class="custom-control-input" id="Select-All-Items2"
                                    [checked]="isAllItemsSelected" (change)="selectAllItems()">
                                <label class="custom-control-label pt-05 text-vf-dark" for="Select-All-Items2"></label>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="search level-5-search">
                                <div class="input-group">
                                    <div class="input-group-prepend h-100">
                                        <div class="input-group-text"><lucide-icon name="search" [size]="16" [strokeWidth]="2"></lucide-icon>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control rounded-8 text-left bg-pure-white"
                                        placeholder="Search" (input)="applySearchOnLevel5()"
                                        [(ngModel)]="searchTextOnL5">
                                    <div class="input-group-append h-100" style="display: none;">
                                        <button (click)="removeSearchOnLevel5()"
                                            class="input-group-text btn btn-link text-decoration-none px-10">
                                            <ibm-icon-close size="16" class="fill-medium"></ibm-icon-close>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col pl-0 d-flex justify-content-end">
                            <button class="btn modal-header-icon d-flex mr-2" (click)="showAddItem(5)"
                                *ngIf="isSingleSelect">
                                <!-- <lucide-icon name="folder" [size]="14" [strokeWidth]="2" class="mr-2"></lucide-icon> -->
                                <lucide-icon name="folder" [size]="16" class="mr-2"></lucide-icon>
                                <span class="f-size-14 text-vf-dark">Folder</span>
                            </button>
                            <div class="dropdown pr-2" *ngIf="!isSingleSelect">
                                <button class="btn modal-header-icon d-flex" type="button"
                                    id="fileAddDropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <ibm-icon-add size="16" class=""></ibm-icon-add>
                                    <span class="f-size-14 text-vf-dark"></span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right mt-1"
                                    aria-labelledby="fileAddDropdownMenuButton">
                                    <button class="dropdown-item" (click)="showAddItem(1)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                            class="w-16 mr-2" alt="word">
                                        <span class="f-size-14">Word</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(2)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                            class="w-16 mr-2" alt="excel">
                                        <span class="f-size-14">Excel</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(3)">
                                        <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                            class="w-16 mr-2" alt="powerpoint">
                                        <span class="f-size-14 text-none">Powerpoint</span>
                                    </button>
                                    <button class="dropdown-item" (click)="showAddItem(5)">
                                        <ibm-icon-folder-add size="16" class="mr-2 fill-medium"></ibm-icon-folder-add>
                                        <span class="f-size-14 text-none">Create folder</span>
                                    </button>
                                    <button class="dropdown-item" (click)="triggerFileControlL5()">
                                        <ibm-icon-upload size="16" class="mr-2 fill-medium"></ibm-icon-upload>
                                        <span class="f-size-14 text-none">Upload files</span>
                                    </button>
                                    <input type="file" id="fileUploadOneDrive_L5" style="display: none;" multiple
                                        (change)="fileInputChanged($event, false, level)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-section mb-3" *ngIf="isShowAddItem">
                        <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                            <li class="list-group-item cursor-pointer d-flex">
                                <div class="card-wrapper">
                                    <div class="col px-0 d-flex justify-content-center pl-2" *ngIf="!showFolderOnly">
                                        <div class="dropdown">
                                            <button
                                                class="float-right btn pl-0 tk-proxima-nova text-medium dropdown-toggle"
                                                type="button" id="selectDocTypeMenu" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                    *ngIf="selectedDocType === 1" class="w-20 mr-10" alt="word">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                    *ngIf="selectedDocType === 2" class="w-20 mr-10" alt="excel">
                                                <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                    *ngIf="selectedDocType === 3" class="w-20 mr-10" alt="powerpoint">
                                                <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10" *ngIf="selectedDocType === 5"></lucide-icon>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right mt-1"
                                                aria-labelledby="selectDocTypeMenu">
                                                <button class="dropdown-item" (click)="selectDocType(1)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg"
                                                        class="w-20 mr-10" alt="word">
                                                    <span class="f-size-14">Word</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(2)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg"
                                                        class="w-20 mr-10" alt="excel">
                                                    <span class="f-size-14">Excel</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(3)">
                                                    <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg"
                                                        class="w-20 mr-10" alt="powerpoint">
                                                    <span class="f-size-14 text-none">Powerpoint</span>
                                                </button>
                                                <button class="dropdown-item" (click)="selectDocType(5)">
                                                    <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="mr-10"></lucide-icon>
                                                    <span class="f-size-14 text-none">Create folder</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-8 pl-0 d-flex">
                                        <span class="create-input d-flex" *ngIf="selectedDocType !== 5">
                                            <span class="input-text create-file border-none" contenteditable=""
                                                (keypress)="onNewFileKeyPress($event, false, level)"
                                                (blur)="onNewFileBlur($event, false, level)">
                                            </span>
                                        </span>
                                        <span class="create-input d-flex" *ngIf="selectedDocType === 5">
                                            <span class="input-text create-folder border-none" contenteditable=""
                                                (keypress)="onNewFolderKeyPress($event, false, level)"
                                                (blur)="onNewFolderBlur($event, false, level)">
                                            </span>
                                        </span>
                                    </div>
                                    <div class="col d-flex px-0 justify-content-end">
                                        <span class="f-size-14 text-blue cursor-pointer">
                                            <span class="ml-1">Save</span>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div [hidden]="!isSharePointSitesLoading" class="my-10 mx-10">
                        <div class="skeleton skeleton-tile"></div>
                    </div>
                    <perfect-scrollbar [config]="config" (psYReachEnd)="getMoreMyFiles($event)">
                        <div class="card-section pb-2"
                            *ngIf="driveItems.length > 0 && !isSharePointSitesLoading && !isFolderEmpty && !noResultFound">
                            <ul class="list-group text-medium project-file-list-group px-2 pr-10">
                                <ng-template ngFor let-i="index" let-item [ngForOf]="driveItems">
                                    <li class="list-group-item cursor-pointer d-flex" *ngIf="item.isShow">
                                        <div class="card-wrapper">
                                            <div class="col px-0 d-flex justify-content-center">
                                                <div class="custom-control custom-checkbox custom-checkbox-success">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="Opt5-{{item.id}}" [checked]="item.isSelected"
                                                        (change)="selectItem(item)">
                                                    <label class="custom-control-label" for="Opt5-{{item.id}}"></label>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-center"
                                                (click)="item.extension === 'folder' ? getDriveItems(item) : selectItem(item)">
                                                <vf-file-icon [obj]="item" [isSemibold]="true"></vf-file-icon>
                                            </div>
                                            <div class="col-7 pl-1"
                                                (click)="item.extension === 'folder' ? getDriveItems(item) : selectItem(item)">
                                                <div class="row ml-0 flex-nowrap">
                                                    <a class="text-primary text-decoration-none overflow-wrap-anywhere f-size-14"
                                                        href="javascript:;"> {{item.name}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col d-flex px-0 justify-content-end"
                                                (click)="item.extension === 'folder' ? getDriveItems(item) : selectItem(item)">
                                                <lucide-icon name="chevron-right" [size]="10" [strokeWidth]="2"
                                                    *ngIf="item.extension === 'folder'"></lucide-icon>
                                            </div>
                                        </div>
                                    </li>
                                </ng-template>
                            </ul>
                        </div>
                        <div [hidden]="!isMoreDataLoading" class="my-10 mx-10">
                            <div class="skeleton skeleton-tile"></div>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="isFolderEmpty && !isSharePointSitesLoading && !noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                This folder is empty
                            </p>
                        </div>
                        <div class="row mt-5 d-flex justify-content-center"
                            *ngIf="!isFolderEmpty && !isSharePointSitesLoading && noResultFound">
                            <p class="f-size-14 text-center mb-0">
                                We can't find anything matching your search terms.
                            </p>
                        </div>
                    </perfect-scrollbar>
                </div>
            </div>
            <div class="modal-footer text-center pb-0" *ngIf="level === 0">
                <div class="row">
                    <div class="col">
                        <button type="button" id="backToSelectLocation3"
                            [disabled]="isSaving || isSharePointSitesLoading" (click)="clickClose()"
                            class="btn cancel-btn rounded-8 mr-2">Cancel
                        </button>
                        <button type="button" id="SaveLinks4"
                            [disabled]="isSaving || isSharePointSitesLoading || (noOfIsShowItems === 0 && isSingleSelect)"
                            (click)="selectItemAndSave(false)" class="btn btn-black rounded-8">Select
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer text-center pb-0" *ngIf="level === 1">
                <div class="row">
                    <div class="col">
                        <button type="button" id="cancelSelectLocation" (click)="clickClose()"
                            class="btn cancel-btn rounded-8">Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer text-center pb-0" *ngIf="level === 2">
                <div class="row">
                    <div class="col">
                        <button type="button" id="backToSelectLocation"
                            [disabled]="isSaving || isSharePointSitesLoading" (click)="backToSelectLocation()"
                            class="btn cancel-btn rounded-8 mr-2">Back
                        </button>
                        <button type="button" id="SaveLinks1"
                            [disabled]="isSaving || isSharePointSitesLoading || (noOfIsShowItems === 0 && isSingleSelect)"
                            (click)="selectDriveAndSave()" class="btn btn-black rounded-8">Select
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer text-center pb-0" *ngIf="level === 3">
                <div class="row">
                    <div class="col">
                        <button type="button" id="backToSelectLocation1"
                            [disabled]="isSaving || isSharePointSitesLoading" (click)="backToSelectedDrive()"
                            class="btn cancel-btn rounded-8 mr-2">Back
                        </button>
                        <button type="button" id="SaveLinks2"
                            [disabled]="isSaving || isSharePointSitesLoading || (noOfIsShowItems === 0 && isSingleSelect)"
                            (click)="selectDriveItemAndSave()" class="btn btn-black rounded-8">Select
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer text-center pb-0" *ngIf="level === 4">
                <div class="row">
                    <div class="col">
                        <button type="button" id="backToSelectLocation2"
                            [disabled]="isSaving || isSharePointSitesLoading" (click)="goBack()"
                            class="btn cancel-btn rounded-8 mr-2">Back
                        </button>
                        <button type="button" id="SaveLinks3"
                            [disabled]="isSaving || isSharePointSitesLoading || (noOfIsShowItems === 0 && isSingleSelect)"
                            (click)="selectItemAndSave(true)" class="btn btn-black rounded-8">Select
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer text-center pb-0" *ngIf="level > 4">
                <div class="row">
                    <div class="col">
                        <button type="button" id="backToSelectLocation3"
                            [disabled]="isSaving || isSharePointSitesLoading" (click)="goBackSP()"
                            class="btn cancel-btn rounded-8 mr-2">Back
                        </button>
                        <button type="button" id="SaveLinks4"
                            [disabled]="isSaving || isSharePointSitesLoading || (noOfIsShowItems === 0 && isSingleSelect)"
                            (click)="selectItemAndSave(false)" class="btn btn-black rounded-8">Select
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<vf-info-popup [information]="information" [isShow]="isShowInfoPopup" (okClick)="okInfoPopupClicked($event)">
</vf-info-popup>
<vf-modal-shell #fsmErrorShell
  [failure]="true"
  [title]="fsmShellError?.title"
  [message]="fsmShellError?.message"
  [cancelLabel]="fsmShellError?.cancelLabel"
  [saveLabel]="fsmShellError?.saveLabel"
  (cancelClick)="fsmCloseError()"
  (saveClick)="fsmSaveError()">
</vf-modal-shell>